export default {"src":"/education/_next/static/media/teaching-school.d2b2cc74.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};